import React, { useEffect, useState } from "react";
import { useMutation } from "@apollo/client";
import Eth from "ethjs-query";
import { AddBEvent, TagDetailQuery, UpdateBEvent } from "../../api";
import * as Web3 from "web3"; // Import the web3 library
import Modal from "react-modal";
import { ReactComponent as EditIcon } from "../../assets/svg/edit.svg";
import avatrImage from "../../assets/img/dummyImage.png"
const web3 = new Web3(window.ethereum); // Initialize web3 with MetaMask's provider
const ethereum = window.ethereum;

const EditCertificateDetails = ({
  isOpen,
  setCertificateModalOpen,
  index,
  certificates,
  detailsData,
  btid,
}) => {
  const [data, setData] = useState([...certificates]);
  const [error, setError] = useState("");
  const [payloadData, setPayloadData] = useState(
    JSON.parse(detailsData[0].payload)
  );
  const [editData, setEditData] = useState([]);
  const [newImage, setNewImage] = useState(null); // State to store the new image file
  useEffect(() => {
    setEditData(detailsData[0]);
  });
  const onRequestClose = () => {
    setCertificateModalOpen(false);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const newData = [...data];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        // Split the data URI by the comma to get the base64 part
        const imageDataParts = e.target.result.split(",");
        newData[index] = {
          ...newData[index],
          image: imageDataParts[1],
        };
        setNewImage(imageDataParts[1]); // Set the new image data as a base64 string
      };
      reader.readAsDataURL(file);
      // Update the subjectOf array in payloadData
      const updatedPayloadData = {
        ...payloadData,
        subjectOf: newData,
      };
      // Set the updated data back into the state
      setData(newData);
      setPayloadData(updatedPayloadData);
    }
  };
  const [updateBEvent] = useMutation(UpdateBEvent, {
    update(cache, { data: { updateBevent } }) {
      const { tag } = cache.readQuery({
        query: TagDetailQuery,
        variables: { btid },
      });

      // Find and update the specific bevent in the tag's bevents array
      const updatedBevents = tag.bevents.map((bevent) => {
        if (bevent.id === editData.id) {
          return updateBevent;
        }
        return bevent;
      });

      cache.writeQuery({
        query: TagDetailQuery,
        data: { tag: { ...tag, bevents: updatedBevents } },
      });
    },
  });

  const handleUpdateSubmit = async (payload) => {
    setError("");
    if (!payload) {
      setError("Payload is empty or invalid.");
      return;
    }
    const msg = web3.utils.toHex(payload);
    const from = ethereum.selectedAddress;

    if (!from) {
      connect();
      setError("Please connect MetaMask.");
      return;
    }

    const eth = new Eth(ethereum);
    try {
      const sig = await eth.personal_sign(msg, from);

      const recovered = await eth.personal_ecRecover(msg, sig);

      if (recovered.toLowerCase() !== from.toLowerCase()) {
        console.dir({ recovered, from });
      } else {
        // Pass the id of the bevent to update
        updateBEvent({
          variables: {
            id: parseInt(editData.id),
            btid: btid || "",
            from,
            hashfn: editData.hashfn.toString(),
            payload: JSON.stringify(payload),
            sig,
            type: editData.type.toString(),
          },
        });
        setCertificateModalOpen(false);
      }
    } catch (error) {
      console.error("Error signing or recovering:", error);
      setError("Error signing or recovering: " + error.message);
    }
  };

  if (!web3) {
    return (
      <div>
        <p>Install Metamask to insert data</p>
      </div>
    );
  } else {
    return (
      <Modal
        isOpen={isOpen}
        className="custom-modal" // Apply custom class for modal styles
        overlayClassName="custom-modal-overlay" // Apply custom class for overlay styles
      >
        <div>
          <div className="w-full py-3 mb-3">
            <label className="block mb-2 text-sm font-medium text-gray-600">
              Image
            </label>
            <input
              type="file"
              name="image"
              // value={data[index].image}
              onChange={handleImageChange}
              className="w-full border border-gray-500 rounded py-2 px-3"
              placeholder="Choose image"
            />
          </div>
          <div>
            {newImage ? (
              <img
                src={`data:image/jpeg;base64,${newImage}`}
                style={{ width: "100px", height: "100px" }}
              />
            ) : (
              <img
                src={data[index].image && data[index].image.trim() ? `data:image/jpeg;base64,${data[index].image}` : avatrImage}
                style={{ width: "100px", height: "100px" }}
              />
            )}
          </div>
          <p className="text-xs italic text-red-600">{error}</p>
          <button
            onClick={() => handleUpdateSubmit(payloadData)}
            className="px-4 py-2 mt-5 font-bold text-white bg-purple-500 rounded shadow hover:bg-purple-400 focus:shadow-outline focus:outline-none"
          >
            Update
          </button>

          <button
            onClick={onRequestClose}
            className="px-4 py-2 mx-2 mt-5 font-bold text-white bg-purple-500 rounded shadow hover:bg-purple-400 focus:shadow-outline focus:outline-none"
          >
            Cancel
          </button>
        </div>
      </Modal>
    );
  }
};

export default EditCertificateDetails;
function connect() {
  if (typeof ethereum !== "undefined") {
    ethereum.enable().catch(console.error);
  }
}
